import NoProfile from "src/assets/img/user-default.png";
import NoFavi from "src/assets/img/favi-default.png";
import NoLogo from "src/assets/img/logo-default.png";
import NoBusiness from "src/assets/img/business-default.png";

/* Digital Ocean: Example */
export const baseUrl = "https://edriving-admin-api-q2ii3.ondigitalocean.app";
export const apiPort = "";

/* Production */
// export const baseUrl = "https://portaladmin.edriving.com:3001";
// export const apiPort = ":" 3001;


/* Localhost */
// export const baseUrl = "http://localhost:3001";
// export const apiPort = ":" + 3001;

export const host = baseUrl + "/api";
export const hostUrl = host + "";
export const filePath = baseUrl + "/uploads";
export const noProfile = NoProfile;
export const noFavi = NoFavi;
export const noLogo = NoLogo;
export const noBusiness = NoBusiness;
